/*
 * AMEND B2C product delivery sync
 * Uses the already-configured Cart Drawer delivery settings as the single source of truth.
 */
(function () {
  'use strict';

  function numberValue(value, fallback) {
    var parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function dayWord(value) {
    return value === 1 ? 'Werktag' : 'Werktagen';
  }

  function syncDeliveryInfo() {
    var source = document.querySelector('[data-amend-delivery-source]');
    var targets = document.querySelectorAll('[data-amend-product-shipping]');
    if (!source || !targets.length) return;

    var processing = numberValue(source.dataset.processingDays, 0);
    var effective = numberValue(source.dataset.processingDaysEffective, processing);
    var transitMin = numberValue(source.dataset.transitMinDays, 2);
    var transitMax = numberValue(source.dataset.transitMaxDays, transitMin);
    var vacationExtra = numberValue(source.dataset.vacationExtraDays, 0);
    var vacation = source.dataset.vacationEnabled === 'true';
    var noticeEnabled = source.dataset.noticeEnabled === 'true';
    var noticeText = (source.dataset.noticeText || '').trim();
    var prefix = (source.dataset.deliveryPrefix || '').trim();
    var deliveryWindow = (source.dataset.deliveryWindow || '').trim();

    targets.forEach(function (target) {
      var processingNode = target.querySelector('[data-amend-shipping-processing]');
      var transitNode = target.querySelector('[data-amend-shipping-transit]');
      var estimateNode = target.querySelector('[data-amend-shipping-estimate]');
      var noticeNode = target.querySelector('[data-amend-shipping-notice]');

      if (processingNode) {
        if (vacation) {
          if (vacationExtra > 0) {
            processingNode.textContent = 'Aktuell sind wir im Urlaub. Zur regulären Bearbeitungszeit kommen derzeit ' + vacationExtra + ' zusätzliche ' + dayWord(vacationExtra) + ' hinzu. Insgesamt rechnen wir aktuell mit ' + effective + ' ' + dayWord(effective) + ' bis zur Versandübergabe.';
          } else {
            processingNode.textContent = 'Aktuell ist der Urlaubsmodus aktiv. Die hinterlegte Bearbeitungszeit beträgt derzeit ' + effective + ' ' + dayWord(effective) + ' bis zur Versandübergabe.';
          }
        } else if (processing === 0) {
          processingNode.textContent = 'Wir bereiten deine Bestellung in der Regel ohne zusätzliche Bearbeitungstage für den Versand vor.';
        } else {
          processingNode.textContent = 'Wir bereiten deine Bestellung in der Regel innerhalb von ' + processing + ' ' + dayWord(processing) + ' für den Versand vor.';
        }
      }

      if (transitNode) {
        if (transitMin === transitMax) {
          transitNode.textContent = 'Die anschließende Transportzeit beträgt in der Regel etwa ' + transitMin + ' ' + dayWord(transitMin) + '.';
        } else {
          transitNode.textContent = 'Die anschließende Transportzeit beträgt in der Regel etwa ' + transitMin + '–' + transitMax + ' Werktage.';
        }
      }

      if (estimateNode) {
        var estimate = [prefix, deliveryWindow].filter(Boolean).join(' ');
        estimateNode.textContent = estimate || 'wird im Warenkorb berechnet';
      }

      if (noticeNode) {
        if (noticeEnabled && noticeText) {
          noticeNode.textContent = noticeText;
          noticeNode.hidden = false;
        } else {
          noticeNode.textContent = '';
          noticeNode.hidden = true;
        }
      }
    });
  }

  function scheduleSync() {
    window.requestAnimationFrame(syncDeliveryInfo);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncDeliveryInfo, { once: true });
  } else {
    syncDeliveryInfo();
  }

  document.addEventListener('shopify:section:load', scheduleSync);
  document.addEventListener('shopify:section:reorder', scheduleSync);

  var observer = new MutationObserver(function (mutations) {
    var relevant = mutations.some(function (mutation) {
      return Array.prototype.some.call(mutation.addedNodes || [], function (node) {
        return node.nodeType === 1 && (
          (node.matches && (node.matches('[data-amend-delivery-source]') || node.matches('[data-amend-product-shipping]'))) ||
          (node.querySelector && (node.querySelector('[data-amend-delivery-source]') || node.querySelector('[data-amend-product-shipping]')))
        );
      });
    });
    if (relevant) scheduleSync();
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
